import React from 'react';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';

const Notification = ({notification, setNotification}) => {

  const handleCloseAlert = () => {
    setNotification({...notification, visible: false});
  };

  return (
    <Snackbar
      anchorOrigin={{vertical: 'top', horizontal: 'center'}} open={notification.visible} onClose={handleCloseAlert}>
      <Alert severity={notification.type}>
        {notification.message}
      </Alert>
    </Snackbar>
  );
};

export default Notification;